import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { messagesActions } from 'store/messages'
import { settingsActions } from 'store/settings'

/**
 * Single source of truth for logging the user out of the portal: wipes the
 * whole message slice (active chat, cached chats, transcript and typing/init
 * flags), the ticket reminder flag, and the auth session (token + user).
 *
 * The full message reset matters because the store is persisted to
 * localStorage (redux-persist, no blacklist) — a partial clear would leave the
 * previous user's conversation behind.
 *
 * Reused by the manual logout entry points (WidgetHeader, ProfileModal,
 * ChatPageSidebar) and by the `mimirLogout` postMessage handler the parent host
 * (zenithar) sends when its own user logs out.
 */
export const useLogout = (): (() => void) => {
  const dispatch = useDispatch()

  return useCallback(() => {
    dispatch(messagesActions.resetMessageState())
    dispatch(settingsActions.setTicketReminderVisible(false))
    dispatch(settingsActions.logout())
  }, [dispatch])
}
